import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

import { OrderDetailDialogComponent } from './tpl3pl-export-queue/tpl3pl-export-queue.component';
import { AttachSavedCardToOrderDialogComponent } from './tpl3pl-shipments/attach-saved-card-to-order-dialog.component';

/**
 * Material dialogs opened via MatDialog from multiple feature areas (3PL queue, shipments, open orders list).
 */
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatTooltipModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatRadioModule,
	],
	declarations: [OrderDetailDialogComponent, AttachSavedCardToOrderDialogComponent],
})
export class Tpl3plOrderDetailDialogModule {}
